import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const HelpIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M7.33333 12h1.33334v-1.3334H7.33333V12ZM8 1.33331c-3.68 0-6.66667 2.98667-6.66667 6.66667C1.33333 11.68 4.32 14.6666 8 14.6666c3.68 0 6.6667-2.9866 6.6667-6.66662 0-3.68-2.9867-6.66667-6.6667-6.66667ZM8 13.3333c-2.94 0-5.33333-2.3933-5.33333-5.33332 0-2.94 2.39333-5.33333 5.33333-5.33333s5.3333 2.39333 5.3333 5.33333C13.3333 10.94 10.94 13.3333 8 13.3333Zm0-9.33332c-1.47333 0-2.66667 1.19333-2.66667 2.66667h1.33334c0-.73334.6-1.33334 1.33333-1.33334.73333 0 1.33333.6 1.33333 1.33334 0 1.33333-2 1.16666-2 3.33333h1.33334c0-1.5 2.00003-1.66667 2.00003-3.33333 0-1.47334-1.19337-2.66667-2.6667-2.66667Z" />
  </Icon>
);

export default memo(HelpIcon);
